::ng-deep .alert{margin-bottom:0}.top-shadow{box-shadow:0 -4px 6px -1px #0000001a,0 -2px 4px -1px #0000000f}
/*# sourceMappingURL=connections-overview.component-EJWRRZUJ.css.map */
